import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { environment } from '../environments/environment'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from  '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { HeaderComponent } from './header/header.component';
import { TopInfoBlockComponent } from './top-info-block/top-info-block.component';
import { StudentViewComponent } from './student-view/student-view.component';
import { TeacherConfigViewComponent } from './teacher-config-view/teacher-config-view.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { TeacherQuizViewComponent } from './teacher-quiz-view/teacher-quiz-view.component';
import { CountdownModule } from 'ngx-countdown';
import { StudentQuizViewComponent } from './student-quiz-view/student-quiz-view.component';
import { HistoricalViewComponent } from './historical-view/historical-view.component';
import { ActiveUsersViewComponent } from './active-users-view/active-users-view.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { TextViewComponent } from './text-view/text-view.component';
import 'firebase/analytics';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    TopInfoBlockComponent,
    StudentViewComponent,
    TeacherConfigViewComponent,
    TeacherQuizViewComponent,
    StudentQuizViewComponent,
    HistoricalViewComponent,
    ActiveUsersViewComponent,
    TextViewComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatDividerModule,
    MatCardModule,
    MatInputModule,
    MatListModule,
    MatIconModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    CountdownModule,
    MatToolbarModule,
    MatSliderModule,
    GoogleChartsModule
    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
